/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import { useRequest } from '../../hooks/UseRequest'
import Loading from '../../components/Loading'
import DashletSuccessIcon from '../../components/elements/DashletSuccessIcon'
import DashletDeclineIcon from '../../components/elements/DashletDeclineIcon'
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { selectModules } from '../../redux/moduleSlice'
import DashletTooltip from '../../components/elements/DashletTooltip'
import NoRecord from '../../components/elements/NoRecord'
import { setLoanId } from '../../redux/paymentScheduleDataSlice'
import { FormatISODate, CurrencyFormat, PercentFormat } from '../../helpers/formatting'

function LoanDashlet({ endpointPath }) {
  const requests = useRequest()
  const requesting = useRef(false)
  const [row, setRow] = useState([])
  const [loaded, setLoaded] = useState(false)
  const [module, setModule] = useState()
  const modules = useSelector(selectModules)
  const dispatch = useDispatch();

  useEffect(() => {
    const getRow = async () => {
      requests.setEndpoint(endpointPath)
      try {
        const response = await requests.get()
        setRow(response.data.data)
        dispatch(setLoanId(response?.data?.data?.id))
        const m = modules.data.find((e) => e.code_key === 'loan')
        setModule(m)
        setLoaded(true)
      } catch (error) {
        setLoaded(true)
      }
    }
    if (!requesting.current && endpointPath && row.length === 0) {
      setLoaded(false)
      requesting.current = true
      getRow()
    }
  }, [endpointPath])

  const renderHeader = (column_name, customize_label = false) => {
    if (customize_label) {
      return column_name;
    }
    const data = module.module_fields.find(
      (header) => header.column_name === column_name
    )
    if (data && !data.helper_text) {
      return data?.label_name
    }
    return <DashletTooltip columnName={data?.label_name} tooltipText={data?.helper_text} />
  }

  return (
    <div className="message is-white lox-dashlet-detail">
      <div className="message-header has-background-primary has-text-white lox-dashlet-detail__title py-0">
        <p className="is-size-4">Loan Detail</p>
      </div>
      <div className="message-body py-0 px-1" style={{ lineHeight: 1.40 }}>
        {loaded && row && row.id && (
          <>
            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader("id")}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-link is-size-8">
                <Link
                  key={`loan-dashlet-view-${row.id}`}
                  to={`/loan/${row.id}`}
                  className="lox-has-text-decoration-none"
                >
                  {row.id}
                </Link>
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('Loan Status', true)}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {row.loan_status_ddo.name || '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('principal_amount')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                <CurrencyFormat value={row.principal_amount} />
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('Effective Date', true)}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {row.effective_date ? FormatISODate(row?.effective_date) : '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('Interest Rate Applied', true)}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                <PercentFormat value={row.interest_rate || 0} fractionDigits={3} />
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('apr')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                <PercentFormat value={row.apr || 0} fractionDigits={3} />
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('Is Express Loan', true)}
              </p>
              <p className="lox-dashlet-detail__item__data is-size-8 px-0 lox-dashlet-detail__icon">
                {row.is_express_loan == 0 ? <DashletDeclineIcon /> : <DashletSuccessIcon />}{' '}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('Is Returning Customer', true)}
              </p>
              <p className="lox-dashlet-detail__item__data is-size-8 px-0 lox-dashlet-detail__icon">
                {row.is_returning_customer == 0 ? (
                  <DashletDeclineIcon />
                ) : (
                  <DashletSuccessIcon />
                )}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('Customer', true)}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-link is-size-8">
                {row.customer_label || '-'}
              </p>
            </div>
          </>
        )}
        {!loaded && <Loading />}
        {loaded && row.length === 0 && <NoRecord />}
      </div>
    </div>
  )
}

export default LoanDashlet
